var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXWhitebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2656,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49848 16.207C8.20559 16.4999 8.20559 16.9748 8.49848 17.2677C8.79137 17.5606 9.26625 17.5606 9.55914 17.2677L13.7656 13.0612L17.9722 17.2677C18.2651 17.5606 18.7399 17.5606 19.0328 17.2677C19.3257 16.9748 19.3257 16.4999 19.0328 16.207L14.8263 12.0005L19.0328 7.794C19.3257 7.50111 19.3257 7.02624 19.0328 6.73334C18.7399 6.44045 18.2651 6.44045 17.9722 6.73334L13.7657 10.9399L9.55914 6.73334C9.26625 6.44045 8.79137 6.44045 8.49848 6.73334C8.20559 7.02623 8.20559 7.50111 8.49848 7.794L12.705 12.0005L8.49848 16.207Z",
    fill: "#121622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXWhitebg);
export default __webpack_public_path__ + "static/media/icon_x_whitebg.adc2fdff71e28aec1c259d9bd82702e7.svg";
export { ForwardRef as ReactComponent };